<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'name'"
      [formField]="form.get('name')">
      <input
        pInputText
        id="name"
        type="text"
        formControlName="name"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Schlüssel'"
      [name]="'key'"
      [formField]="form.get('key')">
      <input
        pInputText
        id="key"
        type="text"
        formControlName="key"
        class="p-input" />
    </app-form-field-wrapper>
  </div>

  <p-divider></p-divider>

  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.name) : undefined
    "></app-form-footer>
</form>
